module.exports = __webpack_public_path__ + "images/tencent_docs/doc-grid-1ba1c3ab36dcf695783bc4c702ad9d0d.png";